import { render, staticRenderFns } from "./CampaignDelivery.vue?vue&type=template&id=09fb36e4&scoped=true"
import script from "./CampaignDelivery.vue?vue&type=script&lang=js"
export * from "./CampaignDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fb36e4",
  null
  
)

export default component.exports